import React from 'react';
import {
  FDBodyText,
  FDSecondaryActionIconButton,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useCopyToClipboard } from 'Helpers/Utils';
import PropTypes from 'prop-types';

const useStyles = buildUseStyles('CopyToClipboardStat', (() => ({
  value: {
    '& > h5': {
      fontWeight: 'bold',
    },
  },
  label: {
    '& > p': {
      fontSize: '14px',
    },
  },
})));

const CopyToClipboardStat = ({ label, value }) => {
  const classes = useStyles();
  const { copyToClipboard } = useCopyToClipboard();

  return (
    <FDStack direction={'column'} alignItems={'center'} spacing={0}>
      <div className={classes.label}>
        <FDBodyText size={'sm'} value={label} />
      </div>
      <FDStack alignItems={'center'}>
        <FDSecondaryActionIconButton icon={'contentCopy'} disablePadding size={'sm'} onClick={() => copyToClipboard(value)} />
        <div className={classes.value}>
          <FDTitleText size={'lg'} value={value} />
        </div>
      </FDStack>
    </FDStack>
  );
};

CopyToClipboardStat.defaultProps = {
};

CopyToClipboardStat.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default CopyToClipboardStat;
